import Vue from 'vue';
import Vuex from 'vuex';
import Storage from '@/storage/Storage';
import { EventBus } from '@/eventBus';

// Modules
import layout from './layout';
import auth from './auth';
// import billing from './billing';
import modules from './modules';

Vue.use(Vuex);

export default () => {
	return new Vuex.Store({
		state: () => ({
			platform: 'web',
			deviceInfo: {},
			intended: {
				accountId: null,
				path: null,
			},
			refreshOnPageChange: false,
		}),

		getters: {

			hasIntended(state) {
				return state.intended.path !== null;
			},

			intendedRoute(state) {
				let accountId = state.intended.accountId || state.auth.currentAccountId;
				return {
					...state.intended,
					accountId,
				};
			}
		},

		mutations: {

			setPlatform(state, platform) {
				state.platform = platform;
			},

			setDeviceInfo(state, deviceInfo) {
				state.deviceInfo = deviceInfo;
			},

			wipeAccountData(state) {
				// Object.assign(state.billing, billing.state());
			},

			setIntended(state, { accountId, path }) {
				Vue.set(state, 'intended', {
					accountId,
					path
				});

				Storage.set('intended', state.intended);
			},

			clearIntended(state) {
				Storage.remove('intended');
				Vue.set(state, 'intended', {
					accountId: null,
					path: null,
				});
			},

			siteContentUpdated(state) {
				state.refreshOnPageChange = true;
			},

		},

		actions: {

			setPlatform({ commit }, platform) {
				commit('setPlatform', platform);
			},

			setDeviceInfo({ commit }, deviceInfo) {
				commit('setDeviceInfo', deviceInfo);
			},

			async syncAccountData({ dispatch }) {
				await Promise.all([ dispatch('getAccounts'), dispatch('loadModules'), dispatch('loadModuleCounts') ]);
			},

			/**
			 * Clear out data loaded on the client that is account based
			 */
			wipeAccountData({ commit }) {
				commit('wipeAccountData');
			},

			setIntended({ commit }, { path, accountId = null }) {
				commit('setIntended', { accountId, path });
			},

			clearIntended({ commit }) {
				commit('clearIntended');
			},

			goIntended({ getters }, defaultRoute = '/dashboard') {

				let path = defaultRoute;

				if (getters.hasIntended) {
					let intendedRoute = getters.intendedRoute;
					if (!intendedRoute.path) intendedRoute.path = defaultRoute;
					path = '/go/' + intendedRoute.accountId + '?path=' + intendedRoute.path;
				}
				else if (getters.hasPendingInvitation) {
					path = getters.pendingInvitation.responseUrl;
				}

				EventBus.$emit('go', path);
			},

			siteContentUpdated({ commit }) {
				commit('siteContentUpdated');
			}

		},

		modules: {
			layout,
			auth,
			// billing,
			modules,
			// If you're adding a new module that contains account-specific data, update the wipeAccountData mutation
		}
	});
};
